import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import Auth from "../Auth/index";
import Signup from "../Signup/index";
import Login from "../Login/index";
import ForgotPassword from "../ForgotPassword/index";
import ContractsLayout from "../ContractsLayout";
import Contracts from "../Contracts/index";
import ContractShow from "../ContractShow/index";
import CreateContract from "../CreateContract/index";
import UpdateContract from "../UpdateContract/index";
import DealersLayout from "../DealersLayout/index";
import Dealers from "../Dealers/index";
import CreateDealer from "../CreateDealer/index";
import UpdateDealer from "../UpdateDealer/index";
import DashboardLayout from "../DashboardLayout/index";
import CustomersLayout from "../CustomersLayout/index";
import Customers from "../Customers/index";
import CustomerShow from "../CustomerShow/index";
import Settings from "../Settings";
import StaffLayout from "../StaffLayout";
import Staffs from "../Staffs/index";
import CreateStaff from "../CreateStaff/index";
import UpdateStaff from "../UpdateStaff/index";
import Products from "../Products";
import CreateProduct from "../CreateProduct";
import UpdateProduct from "../UpdateProduct";
import ProductShow from "../ProductShow";
import ProductsLayout from "../ProductsLayout";
import { compose } from "recompose";
import WithUserRole from "../WithUserRole";
import WithCurrentDealer from "../WithCurrentDealer";
import JustForCustomer from "../JustForCustomer";
import MyShoppingCart from "../MyShoppingCart";
import Orders from "../Orders";
import Market from "../Market";
import withAuthCheck from "../WithAuthCheck/index";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TrackShow from "../TrackShow";

class App extends Component {
  componentDidUpdate(e) {
    if (
      window.innerWidth < 993 &&
      e.history.location.pathname !== e.location.pathname &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
    }
  }

  render() {
    return (
      <>
        <Switch>
          <Auth exact path="/" component={Login} />
          <Auth exact path="/signup" component={Signup} />
          <Auth path="/reset_password" component={ForgotPassword} />
          <Market
            exact
            path="/dealers/:dealer_id/products"
            component={withAuthCheck(Products)}
          />
          <Market
            exact
            path="/dealers/:dealer_id/products/:productId"
            component={withAuthCheck(ProductShow)}
          />
          <Market
            exact
            path="/dealers/:dealer_id/shopping-cart"
            component={withAuthCheck(MyShoppingCart)}
          />
          <DashboardLayout
            exact
            path="/contracts"
            component={ContractsLayout(withAuthCheck(Contracts))}
          />
          <DashboardLayout
            path="/contracts/new"
            component={ContractsLayout(withAuthCheck(CreateContract))}
          />
          <DashboardLayout
            exact
            path="/contracts/:contract_id/edit"
            component={ContractsLayout(withAuthCheck(UpdateContract))}
          />
          <DashboardLayout
            exact
            path="/contracts/:contract_id/tracking"
            component={ContractsLayout(withAuthCheck(TrackShow))}
          />
          <DashboardLayout
            path="/contracts/:contract_id"
            component={ContractsLayout(withAuthCheck(ContractShow))}
          />
          <DashboardLayout
            exact
            path="/dealers"
            component={DealersLayout(withAuthCheck(Dealers))}
          />
          <DashboardLayout
            path="/dealers/new"
            component={DealersLayout(withAuthCheck(CreateDealer))}
          />
          <DashboardLayout
            path="/dealers/:dealer_id/edit"
            component={DealersLayout(withAuthCheck(UpdateDealer))}
          />
          <DashboardLayout
            exact
            path="/customers/:customer_id"
            component={CustomersLayout(withAuthCheck(CustomerShow))}
          />
          <DashboardLayout
            exact
            path="/customers"
            component={CustomersLayout(withAuthCheck(Customers))}
          />
          <DashboardLayout
            exact
            path="/settings"
            component={withAuthCheck(Settings)}
          />
          <DashboardLayout
            exact
            path="/staff"
            component={StaffLayout(withAuthCheck(Staffs))}
          />
          <DashboardLayout
            exact
            path="/staff/new"
            component={StaffLayout(withAuthCheck(CreateStaff))}
          />
          <DashboardLayout
            path="/staff/:staff_id/edit"
            component={StaffLayout(withAuthCheck(UpdateStaff))}
          />
          <DashboardLayout
            exact
            path="/products"
            component={ProductsLayout(withAuthCheck(Products))}
          />
          <DashboardLayout
            exact
            path="/orders"
            component={ProductsLayout(withAuthCheck(Orders))}
          />
          <DashboardLayout
            exact
            path="/products/new"
            component={StaffLayout(withAuthCheck(CreateProduct))}
          />
          {/* marcos */}
          <DashboardLayout
            exact
            path="/products/:productId/edit"
            component={StaffLayout(withAuthCheck(UpdateProduct))}
          />
          {/* /marcos */}
          <DashboardLayout
            exact
            path="/products/:productId"
            component={ProductsLayout(withAuthCheck(ProductShow))}
          />

          <DashboardLayout
            exact
            path="/shopping-cart"
            component={withAuthCheck(
              compose(
                WithUserRole,
                WithCurrentDealer,
                JustForCustomer
              )(MyShoppingCart)
            )}
          />
          <Route render={() => <h2> Page not found </h2>} />
        </Switch>
        <ToastContainer autoClose={3000} hideProgressBar />
      </>
    );
  }
}

export default App;
